import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createContactUs(data) {
  return axiosInstance.post(`contact`, formatRequest(data));
}
